module.exports = __webpack_public_path__ + "img/brand_02.6e65ca81.png";